<template>
    <div id="self-serve-loading">
        <Header
            :checkoutStep="{display: true, step: 1}"
            :categoryFilter="{display: true}"
            :shoppingBag="{display: false}">
        </Header>
        <LoadingScreen v-if="loading"></LoadingScreen>
        <div id="self-serve-sign-in" v-else>
            <div class="loading-text sign-in-modal">
                <div class="samsara-logo">
                    <svg width="36" height="48" viewBox="0 0 36 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M17.7198 0C7.92808 0 0 7.75592 0 17.335V30.665C0 40.2441 7.92808 48 17.7198 48C27.5115 48 35.4396 40.2441 35.4396 30.665V17.335C35.4396 7.75592 27.5115 0 17.7198 0ZM7.42398 33.4894C7.42398 34.0722 6.95044 34.5355 6.35469 34.5355C5.75893 34.5355 5.28539 34.0722 5.28539 33.4894V32.5181C5.28539 31.9352 5.75893 31.472 6.35469 31.472C6.95044 31.472 7.42398 31.9352 7.42398 32.5181V33.4894ZM13.1218 41.0959C13.1218 41.6787 12.6483 42.142 12.0525 42.142C11.4568 42.142 10.9832 41.6787 10.9832 41.0959V40.1245C10.9832 39.5417 11.4568 39.0785 12.0525 39.0785C12.6483 39.0785 13.1218 39.5417 13.1218 40.1245V41.0959ZM13.1218 36C13.1218 36.5828 12.6483 37.0461 12.0525 37.0461C11.4568 37.0461 10.9832 36.5828 10.9832 36V35.0286C10.9832 34.4458 11.4568 33.9826 12.0525 33.9826C12.6483 33.9826 13.1218 34.4458 13.1218 35.0286V36ZM18.8196 43.472C18.8196 44.0548 18.3461 44.5181 17.7503 44.5181C17.1546 44.5181 16.6811 44.0548 16.6811 43.472V42.5006C16.6811 41.9178 17.1546 41.4545 17.7503 41.4545C18.3461 41.4545 18.8196 41.9178 18.8196 42.5006V43.472ZM18.8196 38.3761C18.8196 38.9589 18.3461 39.4222 17.7503 39.4222C17.1546 39.4222 16.6811 38.9589 16.6811 38.3761V37.4047C16.6811 36.8219 17.1546 36.3587 17.7503 36.3587C18.3461 36.3587 18.8196 36.8219 18.8196 37.4047V38.3761ZM24.5328 41.0959C24.5328 41.6787 24.0592 42.142 23.4635 42.142C22.8677 42.142 22.3942 41.6787 22.3942 41.0959V40.1245C22.3942 39.5417 22.8677 39.0785 23.4635 39.0785C24.0592 39.0785 24.5328 39.5417 24.5328 40.1245V41.0959ZM24.5328 36C24.5328 36.5828 24.0592 37.0461 23.4635 37.0461C22.8677 37.0461 22.3942 36.5828 22.3942 36V35.0286C22.3942 34.4458 22.8677 33.9826 23.4635 33.9826C24.0592 33.9826 24.5328 34.4458 24.5328 35.0286V36ZM30.2306 33.4894C30.2306 34.0722 29.757 34.5355 29.1613 34.5355C28.5655 34.5355 28.092 34.0722 28.092 33.4894V32.5181C28.092 31.9352 28.5655 31.472 29.1613 31.472C29.757 31.472 30.2306 31.9352 30.2306 32.5181V33.4894ZM18.2239 32.5629C18.0559 32.5928 17.9031 32.6227 17.7351 32.6227C17.567 32.6227 17.399 32.6077 17.2463 32.5629C8.75297 30.6202 2.826 23.9103 2.826 16.259C2.826 11.8356 4.93405 7.60648 8.34053 5.21544C11.1207 3.27273 14.4202 2.77958 17.6587 3.85554C17.7198 3.87049 17.7809 3.87049 17.842 3.85554C21.0652 2.77958 24.38 3.27273 27.1602 5.21544C30.5514 7.60648 32.6747 11.8356 32.6747 16.259C32.6289 23.9103 26.7019 30.6052 18.2239 32.5629Z" fill="#00263E"/>
                        <path d="M26.0144 6.72474C23.7536 5.14068 21.0498 4.73719 18.4224 5.60394C17.9641 5.75338 17.4753 5.75338 17.017 5.60394C16.1005 5.30506 15.184 5.15562 14.2674 5.15562C12.5718 5.15562 10.9068 5.67866 9.42502 6.72474C6.52264 8.77206 4.70483 12.4184 4.70483 16.259C4.70483 23.0435 10.036 29.0062 17.6586 30.7546C17.7044 30.7696 17.735 30.7696 17.7808 30.7546C25.4034 29.0062 30.7346 23.0435 30.7346 16.259C30.7346 12.4184 28.9321 8.75712 26.0144 6.72474ZM27.6031 15.6911C27.1601 16.6625 26.488 17.4246 25.602 17.9775C25.0979 18.2914 24.548 18.5006 23.9828 18.6351C23.4634 18.7397 22.9593 18.4259 22.8524 17.9327C22.7301 17.4246 23.0662 16.9315 23.5703 16.8269C23.9369 16.7521 24.273 16.6027 24.5938 16.4084C25.159 16.0647 25.5867 15.5716 25.8769 14.9439C26.0144 14.6301 25.9991 14.2714 25.8158 13.9726C25.6325 13.6737 25.327 13.4944 24.9757 13.4794C24.105 13.4196 23.4175 13.6737 22.8676 14.2266C21.9358 15.1382 21.5539 16.797 21.3859 17.4993C21.2484 18.0672 19.9347 23.5666 19.1862 26.6749C19.0334 27.3325 18.4377 27.7808 17.7503 27.7808C17.0629 27.7808 16.4671 27.3175 16.3144 26.6749C15.5658 23.5666 14.2369 18.0672 14.1147 17.5143C13.9466 16.797 13.5647 15.1382 12.6329 14.2266C12.0677 13.6737 11.3803 13.4346 10.5249 13.4794C10.1735 13.4944 9.86802 13.6737 9.68471 13.9726C9.5014 14.2714 9.47085 14.6301 9.62361 14.9439C9.91384 15.5716 10.3416 16.0647 10.9068 16.4084C11.2276 16.6027 11.5636 16.7372 11.9302 16.8269C12.4496 16.9464 12.7704 17.4396 12.6482 17.9327C12.526 18.4408 12.0219 18.7397 11.5178 18.6351C10.9526 18.5155 10.4027 18.2914 9.89857 17.9775C9.01258 17.4246 8.32517 16.6625 7.89745 15.6911C7.50028 14.8244 7.57666 13.8082 8.08076 13.0012C8.58486 12.1942 9.47085 11.6712 10.4332 11.6114C11.8233 11.5367 13.0606 11.9701 14.0077 12.8966C15.3214 14.1818 15.795 16.2142 15.9936 17.0809C16.1005 17.5442 17.0323 21.4296 17.7808 24.523C18.5293 21.4445 19.4611 17.5591 19.5681 17.0958C19.7667 16.2291 20.2402 14.1967 21.5539 12.9115C22.4857 12 23.7231 11.5516 25.1284 11.6264C26.0908 11.6861 26.9768 12.1942 27.4809 13.0161C27.9239 13.8082 28.0003 14.8094 27.6031 15.6911Z" fill="#00263E"/>
                    </svg>
                    <div class="loading-text modal-title">
                        <span>Does your organization already<br/> have a Samsara account?</span>
                    </div>
                    <div class="loading-text modal-body">
                        <span>Sign in to access customized offerings <br/>for your account.</span>
                    </div>
                    <div class="loading-text sign-in-button-wrapper">
                        <button class="sign-in-button" v-on:click="signIn">Sign In</button>
                    </div>
                    <div class="loading-text guest-button-wrapper">
                        <button class="guest-button" v-on:click="continueAsGuest">Continue as Guest</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import Header from '../../layouts/header';
import LoadingScreen from '../loading-screen';

export default {
    data() {
        return {
            loading: false
        }
    },
    components: {
        Header,
        LoadingScreen,
    },
    methods: {
        continueAsGuest() {
            this.loading = true;
            axios.post('/webstore/dedupe').then((response) => {
                if (response.status === 200) {
                    axios.get('/shop').then(() => {
                        this.$router.push({path: '/shop'});
                    }).catch(() => {
                        this.$router.push({path: '/message', query: {type: 'errorCreatingCheckout'}});
                    });
                }
                else {
                    this.$router.push({path: '/message', query: {type: 'errorCreatingCheckout'}});
                }
            }).catch(() => {
                this.$router.push({path: '/message', query: {type: 'errorCreatingCheckout'}});
            });
        },
        signIn() {
            window.open('https://cloud.samsara.com/webstore', '_blank');
        }
    }
}
</script>

<style scoped>
#self-serve-loading {
    overflow: hidden;
}

.loading-text {
    display: flex;
    position: absolute;
    left: 0;
    right: 0;
    align-items: center;
    justify-content: center;
}

.sign-in-modal {
    position: absolute;
    width: 671px;
    height: 477px;
    top: 200px;
    margin: 0 auto;
    background: #FFFFFF;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
    border-radius: 32px;

}

.samsara-logo {
    display: flex;
    position: absolute;
    top: 74px;
    align-items: center;
    justify-content: center;
}

.modal-title {
    font-family: "Inter", sans-serif;
    font-weight: 600;
    font-size: 24px;
    line-height: 115%;
    top: 68px;
    width: 671px;
    left: auto;
    right: auto;
    display: flex;
    align-items: center;
    text-align: center;
    color: #00263E;
}

.modal-body {
    font-family: "Inter", sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    top: 114px;
    width: 671px;
    left: auto;
    right: auto;
    line-height: 120%;
    text-align: center;
    color: #00263E;
}

.sign-in-button-wrapper {
    top: 210px;
    left: auto;
    right: auto;
}

.sign-in-button {
    background: #0384FB;
    width: 220px;
    height: 48px;
    border: 0;
    border-radius: 24px;
    font-family: "Nitti Grotesk", sans-serif;
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    line-height: 24px;
    text-align: center;
    color: #FFFFFF;
}

.guest-button-wrapper {
    top: 280px;
    left: auto;
    right: auto;
}

.guest-button {
    background: #FFFFFF;
    width: 220px;
    height: 48px;
    border: 3px solid #0384FB;
    border-radius: 24px;
    font-family: "Nitti Grotesk", sans-serif;
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    line-height: 24px;
    text-align: center;
    color: #0384FB;
}
</style>
